import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from 'components';
import { P } from 'components/Typography/Typography';
import { t } from 'i18next';
import type { RulesTextColor } from './passwordRulesPresentation';

type Props = {
  rulesIcon: IconDefinition;
  rulesIconColor: string;
  rulesTitleColor: RulesTextColor;
  rulesBodyColor: RulesTextColor;
};

export const PasswordRulesHint = ({
  rulesIcon,
  rulesIconColor,
  rulesTitleColor,
  rulesBodyColor
}: Props) => (
  <Flex flexDirection="row" alignItems="flex-start" maxWidth="100%">
    <FontAwesomeIcon
      icon={rulesIcon}
      color={rulesIconColor}
      style={{ marginTop: '0.2em', flexShrink: 0 }}
    />
    <Flex flexDirection="column" ml={2}>
      <P variant="body" color={rulesTitleColor}>
        {t('auth.passRulesTitle')}
      </P>
      <P variant="body" color={rulesBodyColor} mt={1}>
        {t('auth.passRulesBody')}
      </P>
    </Flex>
  </Flex>
);
